import { generateMonochromePalette } from 'utils/highcharts.utils'

export const getDonutChartOptions = ({ data, title, subtitle = '', useFormatter = false, onPointClick = null }) => {
  const total = data.reduce((sum, item) => sum + item.y, 0)
  const colors = generateMonochromePalette('#557371', data.length)

  // identify the largest slice
  const maxY = Math.max(...data.map(d => d.y))
  const preparedData = data.map(d => ({
    ...d,
    selected: d.y === maxY,
    sliced: d.y === maxY
  }))

  return {
    chart: {
      type: 'pie',
      height: 600
    },
    title: {
      text: title || `${total} Workers`,
      align: 'center',
      verticalAlign: 'middle',
      style: {
        fontSize: '18px'
      }
    },
    colors,
    subtitle: subtitle
      ? {
          text: subtitle,
          align: 'center',
          verticalAlign: 'middle',
          y: 30
        }
      : undefined,
    plotOptions: {
      pie: {
        allowPointSelect: true,
        cursor: 'pointer',
        ...(typeof onPointClick === 'function'
          ? {
              point: {
                events: {
                  click: function () {
                    onPointClick(this.groupData || this.blockData || this.options?.groupData || this.options?.blockData || this)
                  }
                }
              }
            }
          : {}),
        innerSize: '60%',
        dataLabels: {
          enabled: true,
          ...(useFormatter
            ? {
                formatter: function () {
                  const { name, y, max } = this.point
                  return `<b>${y}/${max}</b> ${name}`
                }
              }
            : {
                format: '{point.name} ({point.y})'
              }),
          style: {
            fontSize: '12px'
          }
        }
      }
    },
    tooltip: {
      pointFormat: useFormatter
        ? '<b>{point.y}</b> of <b>{point.max}</b> in {point.name}'
        : '{point.name}: <b>{point.y}</b>'
    },
    series: [
      {
        name: title || 'Workers',
        colorByPoint: true,
        data: preparedData
      }
    ]
  }
}
